import { render, staticRenderFns } from "./GogoRuntimeRemoteWrapper.vue?vue&type=template&id=635cd906"
import script from "./GogoRuntimeRemoteWrapper.vue?vue&type=script&lang=ts"
export * from "./GogoRuntimeRemoteWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports